<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <dev-bpbj-leadout-record-form :triggerId="triggerId" ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></dev-bpbj-leadout-record-form>
  </j-modal>
</template>

<script>

  import DevBpbjLeadoutRecordForm from './DevBpbjLeadoutRecordForm'
  export default {
    name: 'DevBpbjLeadoutRecordModal',
    components: {
      DevBpbjLeadoutRecordForm
    },
    data () {
      return {
        title:'',
        width:1300,
        visible: false,
        disableSubmit: false,
        triggerId:'',
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.triggerId = null
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.triggerId = record.id
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>